import React from "react";
import { Row } from "react-bootstrap";
import {
  footer,
  bottomFooter, logo, footerForm, formContainer, linksContainer,
  footerContainer, foodboomLogo
} from "./style.mod.scss";
import Link from "components/link";
import Logo from "../../assets/images/olavson-white.svg";
import locale from "locales";
import ActiveCampaignForm from "components/active-campaign-form";
import FoodboomLogo from "../../assets/images/FoodboomLogo.png";

const CustomFooter = ({ data }) => {

  return (
    <>
      <div className={footer}>
        <div className={footerContainer}>
          <Row>
            <Link to="/" className={logo}>
              {window.location.href.includes("foodboom") ? (
                <img src={FoodboomLogo} alt="Foodboom Logo" className={foodboomLogo} />
              ) : (
                <img src={Logo} alt="Logo" className={logo} />
              )}
            </Link>
            <div className={footerForm}>
              <div className={formContainer}>
                <p>{locale.footer.formTitle}</p>
                <ActiveCampaignForm displayCheckbox={false} />
              </div>
            </div>
          </Row>
          <Row>
            <div className={linksContainer}>
              {data?.links.map((link) => {
                return (
                  <Link to={link.url} key={link.title}>
                    <p>{link.title}</p>
                  </Link>
                );
              })}
            </div>
          </Row>
        </div>
      </div>
      <div className={bottomFooter}>
        <h5>&copy; {(new Date().getFullYear())}, <Link to="/">MyOlavson</Link> </h5>
      </div>
    </>
  );
};

export default CustomFooter;
